import {
    LIST_DEPENDENCY_TYPES,
    LIST_DEPENDENCY_TYPES_SUCCESS,
    LIST_DEPENDENCY_TYPES_ERROR,
    ADD_DEPENDENCY_TYPES,
    SAVE_DEPENDENCY_TYPES,
    SAVE_DEPENDENCY_TYPES_SUCCESS,
    SAVE_DEPENDENCY_TYPES_ERROR,
    DELETE_DEPENDENCY_TYPES,
    DELETE_DEPENDENCY_TYPES_SUCCESS,
    DELETE_DEPENDENCY_TYPES_ERROR,
    EDIT_DEPENDENCY_TYPES,
    UPDATE_DEPENDENCY_TYPES,
    UPDATE_DEPENDENCY_TYPES_SUCCESS,
    UPDATE_DEPENDENCY_TYPES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import dependencyTypesData from '../data/dependencyTypes';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'dependencia-tipo';

//LISTAR DEPENDENCY TYPES
export function listDependencyTypesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listDependencyTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const dependencyTypes = response.data;
            //const dependencyTypes = dependencyTypesData;
            //Llamo al dispatch
            dispatch( listDependencyTypesSuccess(dependencyTypes.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listDependencyTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listDependencyTypes = () => ({
    type: LIST_DEPENDENCY_TYPES,
    payload: true
});

const listDependencyTypesSuccess = dependencyTypes => ({
    type: LIST_DEPENDENCY_TYPES_SUCCESS,
    payload: dependencyTypes
});

const listDependencyTypesError = error => ({
    type: LIST_DEPENDENCY_TYPES_ERROR,
    payload: error
});

//ADD DEPENDENCY TYPE
export function addDependencyTypesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addDependencyTypes(false) );
        //Abro el formulario
        showForm();
    }
}

const addDependencyTypes = isEdit => ({
    type: ADD_DEPENDENCY_TYPES,
    payload: isEdit
});

//SAVE DEPENDENCY TYPE
export function saveDependencyTypesAction(dependencyType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveDependencyTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, dependencyType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveDependencyTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveDependencyTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveDependencyTypes = () => ({
    type: SAVE_DEPENDENCY_TYPES,
    payload: true
});


const saveDependencyTypesSuccess = dependencyType => ({
    type: SAVE_DEPENDENCY_TYPES_SUCCESS,
    payload: dependencyType
});

const saveDependencyTypesError = error => ({
    type: SAVE_DEPENDENCY_TYPES_ERROR,
    payload: error
});

//EDIT DEPENDENCY TYPE
export function editDependencyTypesAction(dependencyType, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editDependencyTypes(dependencyType) );
        //Abro el formulario
        showForm();
    }
}

const editDependencyTypes = dependencyType => ({
    type: EDIT_DEPENDENCY_TYPES,
    payload: dependencyType
});

//UPDATE DEPENDENCY TYPE
export function updateDependencyTypesAction(dependencyType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateDependencyTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${dependencyType.id}`, dependencyType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateDependencyTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateDependencyTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateDependencyTypes = () => ({
    type: UPDATE_DEPENDENCY_TYPES,
    payload: true
});

const updateDependencyTypesSuccess = dependencyType => ({
    type: UPDATE_DEPENDENCY_TYPES_SUCCESS,
    payload: dependencyType
});

const updateDependencyTypesError = error => ({
    type: UPDATE_DEPENDENCY_TYPES_ERROR,
    payload: error
});

//DELETE DEPENDENCY TYPE
export function deleteDependencyTypesAction(dependencyType) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteDependencyTypes() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${dependencyType.id}`);
            const response = await clienteAxios.put(`/${controller}/${dependencyType.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteDependencyTypesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteDependencyTypesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteDependencyTypes = () => ({
    type: DELETE_DEPENDENCY_TYPES,
    payload: true
});

const deleteDependencyTypesSuccess = dependencyType => ({
    type: DELETE_DEPENDENCY_TYPES_SUCCESS,
    payload: dependencyType
});

const deleteDependencyTypesError = error => ({
    type: DELETE_DEPENDENCY_TYPES_ERROR,
    payload: error
});